module.exports = __webpack_public_path__ + "img/img_23.73fae33d.png";